/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import Header from "./header";
import Menu from "./menu";
import WebMarket from "./sub_components/webmarket";
import Fancybook from "./fancybook";
import Toast from "./sub_components/toast";
import * as orderService from "../services/orderService";
import * as eventService from "../services/eventService";
import ExpoPopup from "./sub_components/expoPopup";
import BetSlipPopup from "./sub_components/betSlipPopup";
import marketMsg from "./marketMsg.json";
import * as stringParser from "../util/string.util";
import * as authUtil from "../util/auth.util";
import { calculateBetExpouser, calculateFancyMktExpouser, calculateFancyMktExpouserDemo } from "../util/expouser.util";
let mBets = [];
let umBets = [];
let formInterval;
let socket = null;
let dataUpdate = null;
class Event extends Component {
  constructor(props) {
    super(props);
    this.state = {
      game: {},
      event: {},
      gameCode: "",
      selected_market: null,
      selcted_bet_option: null,
      matched_bet: [],
      unmatched_bet: [],
      selected_list: "matched",
      frontData: {},
      runners: [],
      showToast: false,
      toastMsg: "",
      toastType: "",
      loading: false,
      fancyMarkets: [],
      lineMarkets: [],
      showExpo: false,
      lineExpo: {},
      tvUrl: "",
      tvShow: true,
      teamSequence: [],
      loadingBet: false,
      mktFeedBooks: {},
      pinnedEvents: [],
      betLimit: 20,
      betSlipOpen: false,
      deactivatMarkets: [],
      fancyFilter: "all",
      showFancy: true,
      hideMkt: [],
      mainEvtId: "",
      selectedMarket: "",
      pgurl: "",
      // fancyEvtId:"-9999993",
      marketMsg: [],
      subscribedMarkets: [],
    };
  }
  detectMob() {
    const toMatch = [
      "/Android/i",
      "/webOS/i",
      "/iPhone/i",
      "/iPad/i",
      "/iPod/i",
      "/BlackBerry/i",
      "/Windows Phone/i",
    ];
    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }
  updateBook(marketId, book) {
    let feedBooks = this.state.mktFeedBooks;
    feedBooks[marketId] = book;
    this.state.mktFeedBooks = feedBooks;
  }

  componentWillUnmount() {
    clearInterval(dataUpdate);
    
    if(!!this.props.socket){
      this.props.socket.off("demo_room");
  }
  }
  checkingetzero(txt){
    return txt.toString().length === 1 ? '0' : '';
  }

  addDemoBet(bet, prfdt){
    const crdt = new Date();
    const crdtat = `${crdt.getFullYear()}-${this.checkingetzero(crdt.getMonth())}${crdt.getMonth()}-${this.checkingetzero(crdt.getDate())}${crdt.getDate()}T${this.checkingetzero(crdt.getHours())}${crdt.getHours()}:${this.checkingetzero(crdt.getMinutes())}${crdt.getMinutes()}:${this.checkingetzero(crdt.getSeconds())}${crdt.getSeconds()}Z`;
    let demoExpo = sessionStorage.getItem('demoExpo')
    let totalexpo = 0
        if(!!demoExpo && demoExpo !== 'null' && Object.keys(demoExpo).length > 0){
            demoExpo = JSON.parse(demoExpo);
            totalexpo = (Object.values(demoExpo).reduce((a,v) =>  a = a + v , 0 ))
        }
    let resdata = {
        "provider": bet?.market?.provider,
        "orderId": crdt.getTime(),
        "orderType": "LIMIT",
        "eventId": this.props.match.params.event_id,
        "marketId": bet?.marketId,
        "marketName": bet?.market?.marketName,
        "marketType": bet?.market?.marketType,
        "marketBettingType": bet?.market?.bettingType,
        "side": bet?.bet_for?.toUpperCase(),
        // "runnerId": bet.selectionId,
        // "runnerName": "Papua New Guinea",
        "price": bet?.price,
        "amount": !!bet ? parseInt(bet.bet_amount):0,
        "runnersExposure": {
            // "247649": {
            //     "runnerId": 247649,
            //     "exposure": -100,
            //     "sharingUp": -100,
            //     "sharingMe": 0,
            //     "sharingDown": 0
            // },
            // "2857977": {
            //     "runnerId": 2857977,
            //     "exposure": 8,
            //     "sharingUp": 8,
            //     "sharingMe": 0,
            //     "sharingDown": 0
            // }
        },
        "subscriber": prfdt.userId,
        "baseAmount": bet?.bet_amount,
        "createdAt": crdtat,
        "operatorId": prfdt.operatorId,
        "username": prfdt.username,
        "currency": prfdt.currency,
        "currencyConversion": prfdt.currencyConversion,
        "userId": prfdt.userId
    };
    let btexp = 0;
    if(bet?.market?.bettingType === "LINE"){
        resdata['runnerId'] = bet?.market?.metadata?.book?.runners[0][bet.bet_for][0].line
        resdata['runnerName'] = bet?.market?.metadata?.book?.runners[0][bet.bet_for][0].line
        let btarr = [];
        btarr.push(resdata);
        let betexpo = calculateFancyMktExpouserDemo(bet.market, btarr);
        btexp = betexpo.expo;
    } else {

        let betexpo = calculateBetExpouser(bet.market,bet.market.runners,bet?.bet_for?.toLowerCase(),bet.bet_amount,bet.price,true)
        bet?.market?.runners.forEach((itm)=>{
            resdata['runnersExposure'][itm.id] = {};
            resdata['runnersExposure'][itm.id]["runnerId"]= itm.id;
            resdata['runnersExposure'][itm.id]["name"]= itm.name;
            resdata['runnersExposure'][itm.id]["exposure"]= betexpo[itm.id];
            resdata['runnersExposure'][itm.id]["sharingUp"]= 0;
            resdata['runnersExposure'][itm.id]["sharingMe"]= 0;
            resdata['runnersExposure'][itm.id]["sharingDown"]=0;
        })
        resdata['runnerId'] = bet?.selectionId; //resdata['runnersExposure'][bet?.selectionId]["runnerId"];
        resdata['runnerName'] = resdata['runnersExposure'][bet?.selectionId]["name"];
        let expvlarr = Object.values(betexpo)
        btexp = Math.min(...expvlarr);
    }
    // totalexpo = totalexpo + (bet?.market?.bettingType === "LINE" ? 0 : btexp);
    totalexpo = totalexpo + btexp;
    const profData = JSON.parse(localStorage.getItem('profData'));
    let demopl = sessionStorage.getItem('demoPnL')

    let availableBal = profData.balance + totalexpo + (!!demopl ? demopl : 0);
    if(availableBal < 0){
        this.props.notify("Not Enough Balance", "error")
        this.setState({selected_market: "", selcted_bet_option: "", loadingBet: false });
        if(bet?.market?.bettingType === "LINE"){
            // demoExpo[bet?.marketId] = demoExpo[bet?.marketId] - btexp;
            // sessionStorage.setItem('demoExpo',JSON.stringify(demoExpo));
            document.getElementById('btnHdnRecalculateDemoExpo').click();
        }
    } else {
        let res={
            isSuccess: true,
            data: resdata
        }
        this.onOrderPlaced(res, bet);
        // this.setState({ loadingBet: true },()=>{
        //     setTimeout(() => {
        //         // this.setState({ loadingBet: false },()=>{

        //         // })    
        //         this.onOrderPlaced(res);
        //     }, 3000);
        // })
    }
  }


  addBet(bet) {
    const prfdt = JSON.parse(localStorage.getItem('profData'));
    if(prfdt.role === 'DemoClient'){
        // debugger;
        this.addDemoBet(bet, prfdt);
    } else {
      this.setState({ loadingBet: true });
      bet.event_name = this.state.game.event.name;
      bet.competition_Name = this.state.game.competition.name;
      let betData = JSON.parse(localStorage.getItem("betForm"));
      let body = {
        marketId: bet.marketId,
        placeInstruction: {
          orderType: "LIMIT",
          selectionId: parseFloat(betData.selectionId),
          side: !!bet.bet_for ? bet.bet_for.toUpperCase() : "UNKNOWN",
          limitOrder: {
            size: parseFloat(
              parseFloat(betData.bid_amount.toString()).toFixed(2)
            ),
            price: parseFloat(parseFloat(betData.bid_at.toString()).toFixed(2)),
            persistenceType: "PERSIST",
          },
        },
      };
      if (!!betData.bid_line && betData.bid_line > 0) {
        body.placeInstruction.selectionId = betData.bid_line;
      }
      if (bet.market.bettingType === "BOOKMAKER") {
        orderService.placeBMOrder(body).then((res) => {
          this.onOrderPlaced(res, bet);
        });
      } else if (bet.market.bettingType === "LINE") {
        orderService.placeLineOrder(body).then((res) => {
          this.onOrderPlaced(res, bet);
        });
      } else if (bet.market.bettingType === "ODDS") {
        orderService.placeOddsOrder(body).then((res) => {
          this.onOrderPlaced(res, bet);
        });
      }
    }
  }
  onOrderPlaced(res, bet) {
    debugger
    if (res.isSuccess !== false && !res.errors) {
      if (!!res.exception && !!res.exception.message) {
        this.props.notify(res.exception.message, "error");
      } else {
        this.props.notify("Bet Placed Successfully !", "success");
        if (!!res.data && Object.keys(res.data).length > 0) {
          this.orderPlaced(res.data);
        }
      }
      setTimeout(() => {
        this.setState({
          selected_market: "",
          selcted_bet_option: "",
          loadingBet: false,
        });
      }, bet.market.betDelay);
    } else {
      this.setState({
        selected_market: "",
        selcted_bet_option: "",
        loadingBet: false,
      });
      this.props.notify(
        !!res.exception && !!res.exception.message
          ? res.exception.message
          : "Bet failed due to mismatch data.",
        "error"
      );
    }
  }
  showToast(msg, type) {
    let self = this;
    this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
      setTimeout(() => {
        self.setState({ toastMsg: "", toastType: "", showToast: false });
      }, 3000);
    });
  }
  onMessage(data) {
    data = JSON.parse(data);
    this.setState({ frontData: data });
  }
  resultDeclered(payload) {
    let deactivatMarkets = this.state.deactivatMarkets;
    let matchedBets = this.state.matched_bet;
    if (!!payload && !!payload.marketId) {
      deactivatMarkets.push(payload.marketId);
    }
    matchedBets = matchedBets.filter((bet) => {
      return (
        deactivatMarkets.length > 0 &&
        deactivatMarkets.indexOf(bet.marketId) === -1
      );
    });
    this.setState({
      matched_bet: matchedBets,
      deactivatMarkets: deactivatMarkets,
    });
  }
  showExpo(data) {
    this.setState({ showExpo: true, lineExpo: data });
  }
  hidePopup() {
    this.setState({ showExpo: false, betSlipOpen: false, lineExpo: {} });
  }
  calc(theform) {
    var num = theform.original.value,
      rounded = theform.rounded;
    var with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
    rounded.value = with2Decimals;
  }
  updateSocket(skt) {
    socket = skt;
  }

  getAccountData() {
    let data = localStorage.getItem("accountData")
    data = JSON.parse(data)
    return data
  }
  async componentDidMount() {
    
    // debugger
    // let fancyEvetData = await eventService.getUserEventById(this.state.fancyEvtId)
    
    // let all_catalogues = evetData.catalogues
    // // let all_catalogues = evetData.catalogues.concat(fancyEvetData.catalogues)
    // evetData.catalogues = all_catalogues
    
    // let books = Object.assign({}, evetData.metadata.books);
    // // let books = Object.assign({}, evetData.metadata.books, fancyEvetData.metadata.books);
    // evetData.metadata.books = books
    
    
    let userData = localStorage.getItem("tokenData");
    userData = JSON.parse(userData);
    // let main_msgs = await eventService.getEventMktMessages(this.state.mainEvtId)
    // let fancy_msgs = await eventService.getEventMktMessages(this.state.fancyEvtId)
    let msgs = []; // main_msgs
    // let msgs = main_msgs.concat(fancy_msgs)
    if (!(!!userData && !!userData.sub)) {
      authUtil.logout();
        let winnereventdic = localStorage.getItem("winnereventdic");
        let eventid = "";
        let selected_market = "";
        if(!!winnereventdic){
          winnereventdic = JSON.parse(winnereventdic);
          eventid = winnereventdic["eventDicByName"][window.location.pathname.split("/")[1]]["eventid"];
          selected_market = winnereventdic["eventDicByName"][window.location.pathname.split("/")[1]]["selectedMarket"];
        }
      this.setState({ mainEvtId: eventid, selectedMarket: selected_market, pgurl: window.location.pathname},()=>{
        this.componentDidMountTask();
      });
    } else {
        let winnereventdic = localStorage.getItem("winnereventdic");
        let eventid = "";
        let selected_market = "";
        if(!!winnereventdic){
          winnereventdic = JSON.parse(winnereventdic);
          eventid = winnereventdic["eventDicByName"][window.location.pathname.split("/")[1]]["eventid"];
          selected_market = winnereventdic["eventDicByName"][window.location.pathname.split("/")[1]]["selectedMarket"];
        }
      this.setState({ accounts: userData.sub, marketMsg: msgs, mainEvtId: eventid, selectedMarket: selected_market, pgurl: window.location.pathname},()=>{
        this.componentDidMountTask();
      });
    }

  }
  async componentDidMountTask() {
    let userData = localStorage.getItem("tokenData");
    userData = JSON.parse(userData);
    let selectedEvent = {};
    let teamSequence = [];
    let events = [];
    const accData = this.getAccountData();
    let evetData = await eventService.getUserEventById(this.state.mainEvtId);

    let winnereventdic = localStorage.getItem("winnereventdic");
    if(!!winnereventdic){
      winnereventdic = JSON.parse(winnereventdic);
      let eventid = winnereventdic["eventDicByName"][window.location.pathname.split("/")[1]]["eventid"];
      if(eventid.toString() !== evetData.event.id.toString()){
        window.location.reload();
      }
    }
    
    if(!!userData && userData.role === 'DemoClient'){
      socket.on("demo_room", async (data) => {
          let msg = JSON.parse(data);
          if (!!msg.command && ["MARKET_RESULT","MARKET_VOID"].includes(msg.command)) {
              let demoIdSsData = this.state.matched_bet;
              let betindex = -1;
              
              for(let i=0; i<demoIdSsData.length;i++){
                  if(demoIdSsData[i].marketId === msg.payload.message.marketId){
                      betindex = i;
                      break;
                  }
              } 

              if(betindex >-1){
                  demoIdSsData.splice(betindex,1);
                  this.setState({matched_bet:demoIdSsData})
              }

              // msg.payload
          }
      })
    }
    localStorage.removeItem("betForm");
    localStorage.removeItem("betExpo");
    if (evetData.metadata && !!evetData.metadata.score) {
      this.setState({ frontData: evetData.metadata.score });
    }
    if (!evetData.catalogues || evetData.catalogues.length === 0) {
      return false;
    }
    let runners = evetData.catalogues.filter((mkt) => {
      return mkt.marketType === "MATCH_ODDS";
    })[0];
    if (!!runners) {
      runners = runners.runners;
      teamSequence = runners.map((r) => {
        return (r = r.name);
      });
    } else {
      runners = evetData.catalogues[0].runners;
    }
    this.setState({ runners: runners, teamSequence: teamSequence });
    selectedEvent = events.filter((e, i) => {
      return e.id === this.state.mainEvtId;
    });
    let evtList = [this.state.mainEvtId];
    // let evtList = [this.state.mainEvtId, this.state.fancyEvtId]
    if (!!accData && Object.keys(accData).length > 0) {
      await eventService
        .getMatchedBets({ id: evtList.toString() })
        .then((res) => {
          if (!!res && res.isSuccess) {
            mBets = [];
            let userData = localStorage.getItem("tokenData")
                userData = JSON.parse(userData)
                if(!!userData && userData.role === 'DemoClient'){
                  let demoIdSsData = sessionStorage.getItem('demoIdSsData');
                  demoIdSsData = !!demoIdSsData ? JSON.parse(demoIdSsData) : null;
                  if(!!demoIdSsData && !!demoIdSsData[this.state.mainEvtId]){
                      mBets = demoIdSsData[this.props.match.params.event_id]
                  }
                } else {
                  res.items.forEach((bet) => {
                    bet.eventName = evetData.eventName;
                    if (bet.marketBettingType === "LINE") {
                      bet.runnerName = bet.marketName;
                    }
                    mBets.push(bet);
                  });
                }
          }
        });
    }
    // mBets = mBets.reverse()
    evetData.catalogues &&
      evetData.catalogues.forEach((market, i) => {
        // if (!!evetData.metadata.books[market.marketId]) {
        //     // let mktBook = stringParser.deSrlz("book|" + evetData.metadata.books[market.marketId])
        //     let mktBook = JSON.parse(evetData.metadata.books[market.marketId])
        //     evetData.catalogues[i].metadata = {}
        //     evetData.catalogues[i].metadata.book = mktBook
        // }
        if (!!evetData.metadata && !!evetData.metadata.books) {
          // let mktBook = stringParser.deSrlz(evetData.metadata.books[market.marketId])
          let mktBookData = JSON.parse(evetData.metadata.books);
          let mktBook =
            !!mktBookData && mktBookData[market.marketId]
              ? stringParser.deSrlz(mktBookData[market.marketId])
              : null;

          evetData.catalogues[i].metadata = {};
          evetData.catalogues[i].metadata.book = mktBook;
        } else {
          let baseData = {
            marketId: market.marketId,
            status: "OPEN",
            runners: [],
          };
          evetData.catalogues[i].runners.forEach((rnr) => {
            let data = {
              selectionId: rnr.id.toString(),
              status: "ACTIVE",
              back: [
                { price: "0", size: "0", line: "0" },
                { price: "0", size: "0", line: "0" },
                { price: "0", size: "0", line: "0" },
              ],
              lay: [
                { price: "0", size: "0", line: "0" },
                { price: "0", size: "0", line: "0" },
                { price: "0", size: "0", line: "0" },
              ],
            };
            baseData.runners.push(data);
          });
          evetData.catalogues[i].metadata = {};
          evetData.catalogues[i].metadata.book = baseData;
        }
      });
    evetData.catalogues = evetData.catalogues.filter((mkt) => {
      return (
        !!mkt.metadata &&
        !!mkt.metadata.book &&
        (mkt.provider === "SKY" ||
          mkt.provider === "BETFAIR" ||
          (mkt.provider === "BETHUBS" &&
            (mkt.marketType === "LINE" || mkt.marketType === "BOOKMAKER")))
      );
    });
    var moPos = evetData.catalogues.findIndex(function (mkt) {
      return mkt.provider === "BETFAIR" && mkt.marketType === "MATCH_ODDS";
    });
    if (moPos !== -1) {
      let mom = [evetData.catalogues[moPos]];
      evetData.catalogues.splice(moPos, 1);
      evetData.catalogues = mom.concat(evetData.catalogues);
    }
    let fancy_mkts = evetData.catalogues.filter((mkt) => {
      return (
        (mkt.marketType.substring(0, 3) === "SES" ||
          mkt.bettingType === "LINE") &&
        !!mkt.metadata &&
        !!mkt.metadata.book &&
        !!mkt.metadata.book.marketId &&
        mkt.metadata.book.status !== "CLOSED" &&
        mkt.metadata.book.status !== "INACTIVE"
      );
    });
    let line_mkts = [];
    evetData.catalogues = evetData.catalogues.filter((mkt) => {
      return (
        mkt.marketType.substring(0, 3) !== "SES" && mkt.bettingType !== "LINE"
      );
    });
    fancy_mkts = fancy_mkts.sort((a, b) => a.marketId - b.marketId);
    let tvUrl = (!!accData && Object.keys(accData).length > 0) ? evetData.event.tvUrl : "";
    let pinnedEvents = localStorage.getItem("pinnedEvents");
    pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : [];
    this.setState(
      {
        pinnedEvents: pinnedEvents,
        game: evetData,
        matched_bet: mBets,
        unmatched_bet: umBets,
        gameCode: this.props.match.params.event,
        event: selectedEvent,
        loading: false,
        fancyMarkets: fancy_mkts,
        lineMarkets: line_mkts,
        tvUrl: tvUrl,
      },
      () => {
        // setInterval(async () => {
        //     // let main_msgs = await eventService.getEventMktMessages(this.state.mainEvtId)
        //     // let fancy_msgs = await eventService.getEventMktMessages(this.state.fancyEvtId)
        //     let msgs = [] // main_msgs
        //     // let msgs = main_msgs.concat(fancy_msgs)
        //     this.setState({ marketMsg: msgs })
        // }, 60000)
        const self = this;
        dataUpdate = setInterval(async function dataUpdater() {
          clearInterval(dataUpdate);
          evetData = await eventService.getUserEventById(self.state.mainEvtId);
          // fancyEvetData = await eventService.getUserEventById(this.state.fancyEvtId)
          if (!evetData.catalogues) {
            dataUpdate = setInterval(dataUpdater, ((!!accData && Object.keys(accData).length > 0) ? 15000 : 60000));
            return false;
          }
          // all_catalogues = evetData.catalogues
          // // all_catalogues = evetData.catalogues.concat(fancyEvetData.catalogues)
          // evetData.catalogues = all_catalogues

          // books = Object.assign({}, evetData.metadata.books);
          // // books = Object.assign({}, evetData.metadata.books, fancyEvetData.metadata.books);
          // evetData.metadata.books = books

          evetData.catalogues &&
            evetData.catalogues.forEach((market, i) => {
              // if (!!evetData.metadata.books[market.marketId]) {
              //     // let mktBook = stringParser.deSrlz("book|" + evetData.metadata.books[market.marketId])
              //     let mktBook = JSON.parse(evetData.metadata.books[market.marketId])
              //     evetData.catalogues[i].metadata = {}
              //     evetData.catalogues[i].metadata.book = mktBook
              // }
              if (!!evetData.metadata && !!evetData.metadata.books) {
                // let mktBook = stringParser.deSrlz(evetData.metadata.books[market.marketId])
                let mktBookData = JSON.parse(evetData.metadata.books);
                let mktBook =
                  !!mktBookData && mktBookData[market.marketId]
                    ? stringParser.deSrlz(mktBookData[market.marketId])
                    : null;

                evetData.catalogues[i].metadata = {};
                evetData.catalogues[i].metadata.book = mktBook;
              } else {
                let baseData = {
                  marketId: market.marketId,
                  status: "OPEN",
                  runners: [],
                };
                evetData.catalogues[i].runners.forEach((rnr) => {
                  let data = {
                    selectionId: rnr.id.toString(),
                    status: "ACTIVE",
                    back: [
                      { price: "0", size: "0", line: "0" },
                      { price: "0", size: "0", line: "0" },
                      { price: "0", size: "0", line: "0" },
                    ],
                    lay: [
                      { price: "0", size: "0", line: "0" },
                      { price: "0", size: "0", line: "0" },
                      { price: "0", size: "0", line: "0" },
                    ],
                  };
                  baseData.runners.push(data);
                });
                evetData.catalogues[i].metadata = {};
                evetData.catalogues[i].metadata.book = baseData;
              }
            });
          evetData.catalogues = !!evetData.catalogues
            ? evetData.catalogues.filter((mkt) => {
              return (
                !!mkt.metadata &&
                !!mkt.metadata.book &&
                (mkt.provider === "SKY" ||
                  mkt.provider === "BETFAIR" ||
                  (mkt.provider === "BETHUBS" 
                  // &&
                    // (mkt.marketType.substring(0, 3) === "SES" ||
                    //   mkt.marketType.substring(0, 2) === "BM")
                      ))
              );
            })
            : [];
          var moPos = evetData.catalogues.findIndex(function (mkt) {
            return (
              mkt.provider === "BETFAIR" && mkt.marketType === "MATCH_ODDS"
            );
          });
          if (moPos !== -1) {
            let mom = [evetData.catalogues[moPos]];
            evetData.catalogues.splice(moPos, 1);
            evetData.catalogues = mom.concat(evetData.catalogues);
          }
          let fancy_mkts = evetData.catalogues.filter((mkt) => {
            return (
              (mkt.marketType.substring(0, 3) === "SES" ||
                mkt.bettingType === "LINE") &&
              !!mkt.metadata &&
              !!mkt.metadata.book &&
              !!mkt.metadata.book.marketId &&
              mkt.metadata.book.status !== "CLOSED" &&
              mkt.metadata.book.status !== "INACTIVE"
            );
          });
          evetData.catalogues = evetData.catalogues.filter((mkt) => {
            return (
              mkt.marketType.substring(0, 3) !== "SES" &&
              mkt.bettingType !== "LINE"
            );
          });
          fancy_mkts = fancy_mkts.sort((a, b) => a.marketId - b.marketId);
          self.setState({ game: {}, fancyMarkets: [] }, () => {
            dataUpdate = setInterval(dataUpdater, ((!!accData && Object.keys(accData).length > 0) ? 15000 : 60000));
            self.setState({
              game: Object.assign({}, evetData),
              fancyMarkets: Object.assign([], fancy_mkts),
            });
          });
        }, ((!!accData && Object.keys(accData).length > 0) ? 15000 : 60000));
      }
    );
  }
  componentDidUpdate(){
    if(this.state.pgurl !== window.location.pathname){
      clearInterval(dataUpdate);
      this.setState(
      {
        pinnedEvents: [],
        game: {},
        matched_bet: [],
        unmatched_bet: [],
        gameCode: "",
        event: {},
        loading: true,
        fancyMarkets: [],
        lineMarkets: [],
        tvUrl: "",
      },()=>{
        let winnereventdic = localStorage.getItem("winnereventdic");
        let eventid = "";
        let selected_market = "";
        if(!!winnereventdic){
          winnereventdic = JSON.parse(winnereventdic);
          eventid = winnereventdic["eventDicByName"][window.location.pathname.split("/")[1]]["eventid"];
          selected_market = winnereventdic["eventDicByName"][window.location.pathname.split("/")[1]]["selectedMarket"];
        }
        this.setState({ mainEvtId: eventid, selectedMarket: selected_market, pgurl: window.location.pathname},()=>{
          this.componentDidMountTask();
        });
      })
    }
  }
  betForm(market, bet, clicked) {
    if (market === null && bet === null) {
      localStorage.removeItem("betForm");
      localStorage.removeItem("betExpo");
    }
    this.setState({ selected_market: market, selcted_bet_option: bet }, () => {
      // debugger
      if (market !== null && bet !== null && clicked) {
        if (window.innerWidth > 767) {
          let screenHeight = window.innerHeight;
          let myBetForm = document.getElementById("betFormBtns").offsetTop;
          let myBetFormPt =
            document.getElementById("betFormBtns").parentNode.parentNode
              .offsetTop;
          if (myBetFormPt + myBetForm > window.scrollY + screenHeight / 2) {
            window.scrollTo(0, myBetForm);
          }
        } else {
          let screenHeight = window.innerHeight;
          let myBetForm = document.getElementById("betFormBtnsMob").offsetTop;
          let myBetFormPt =
            document.getElementById("betFormBtnsMob").parentNode.parentNode
              .offsetTop;
          if (myBetFormPt + myBetForm > window.scrollY + screenHeight / 2) {
            window.scrollTo(window.scrollY, myBetForm);
          }
        }
      }
      let self = this;
      clearTimeout(formInterval);
      formInterval = setTimeout(function intetvalBetForm() {
        if (
          self.state.selected_market === market &&
          self.state.selcted_bet_option === bet
        ) {
          self.betForm(null, null);
        }
      }, 10000);
    });
  }
  formatDate(date) {
    if (!date) {
      return "";
    }
    date = new Date(date);
    let month = [];
    month[0] = "Jan";
    month[1] = "Feb";
    month[2] = "Mar";
    month[3] = "Apr";
    month[4] = "May";
    month[5] = "Jun";
    month[6] = "Jul";
    month[7] = "Aug";
    month[8] = "Sept";
    month[9] = "Oct";
    month[10] = "Nov";
    month[11] = "Dec";
    let mn = date.getMonth() + 1;
    mn = mn > 9 ? mn : "0" + mn;
    let dt = date.getDate();
    dt = dt > 9 ? dt : "0" + dt;
    let hr = date.getHours();
    hr = hr > 9 ? hr : "0" + hr;
    let min = date.getMinutes();
    min = min > 9 ? min : "0" + min;
    let year = date.getFullYear();
    let formatedDate = dt + "/" + mn + "/" + year + " " + hr + ":" + min;
    return formatedDate;
  }
  toggleMultiMarket(eventId) {
    let pinnedEvents = localStorage.getItem("pinnedEvents");
    pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : [];
    let eventIndex = pinnedEvents.indexOf(eventId);
    if (eventIndex === -1) {
      pinnedEvents.push(eventId);
    } else {
      pinnedEvents.splice(eventIndex, 1);
    }
    localStorage.setItem("pinnedEvents", pinnedEvents.toString());
    this.setState({ pinnedEvents: pinnedEvents });
  }
  arrayGroupBy(ary, attr) {
    let group = ary.reduce((r, a) => {
      r[a[attr]] = [...(r[a[attr]] || []), a];
      return r;
    }, {});
    return group;
  }
  // orgenizedFancy(markets) {
  //   if (!markets) {
  //     return {};
  //   }
  //   let newObj = {};

  //   if (!!markets["THREE_SELECTIONS"]) {
  //     newObj["THREE_SELECTIONS"] = markets["THREE_SELECTIONS"];
  //     delete markets["THREE_SELECTIONS"];
  //   }
  //   if (!!markets["OVER"]) {
  //     newObj["OVER"] = markets["OVER"];
  //     delete markets["OVER"];
  //   }
  //   if (!!markets["OTHER"]) {
  //     newObj["OTHER"] = markets["OTHER"];
  //     delete markets["OTHER"];
  //   }
  //   if (!!markets["BATSMAN"]) {
  //     newObj["BATSMAN"] = markets["BATSMAN"];
  //     delete markets["BATSMAN"];
  //   }
  //   newObj = { ...newObj, ...markets };
  //   return newObj;
  // }
  userPropertyUpdate(market) {
    let userMktCondition = localStorage.getItem("accountData");
    userMktCondition = JSON.parse(userMktCondition);
    if (!userMktCondition || !market.marketCondition) {
      return market;
    }
    market.minBet =
      !!userMktCondition && userMktCondition.minBet
        ? Math.max(market.marketCondition.minBet, userMktCondition.minBet)
        : market.marketCondition.minBet;
    if (market.marketCondition.maxBet === 0) {
      market.maxBet = userMktCondition.maxBet;
    } else if (userMktCondition.maxBet === 0) {
      market.maxBet = market.marketCondition.maxBet;
    } else {
      market.maxBet = market.marketCondition.maxBet;
    }
    market.betDelay = Math.max(
      market.marketCondition.betDelay,
      userMktCondition.betDelay
    );
    return market;
  }
  toggleOpenMkt(mktId) {
    let hideMkt = this.state.hideMkt;
    let mktIndex = hideMkt.indexOf(mktId);
    if (mktIndex === -1) {
      hideMkt.push(mktId);
    } else {
      hideMkt.splice(mktIndex, 1);
    }
    this.setState({ hideMkt: hideMkt });
  }
  // arrayGroupBy(ary, attr) {
  //   let group = ary.reduce((r, a) => {
  //     r[a[attr]] = [...(r[a[attr]] || []), a];
  //     return r;
  //   }, {});
  //   return group;
  // }
  orgenizedFancy(markets) {
    if (!markets) {
      return {};
    }
    let newObj = {};
    if (!!markets["THREE_SELECTIONS"]) {
      newObj["THREE_SELECTIONS"] = markets["THREE_SELECTIONS"];
      delete markets["THREE_SELECTIONS"];
    }
    if (!!markets["OTHER"]) {
      newObj["OTHER"] = markets["OTHER"];
      delete markets["OTHER"];
    }
    if (!!markets["BATSMAN"]) {
      newObj["BATSMAN"] = markets["BATSMAN"];
      delete markets["BATSMAN"];
    }
    if (!!markets["OVERS"]) {
      newObj["OVERS"] = markets["OVERS"];
      delete markets["OVERS"];
    }
    if (!!markets["SINGLE_OVER"]) {
      newObj["SINGLE_OVER"] = markets["SINGLE_OVER"];
      delete markets["SINGLE_OVER"];
    }
    if (!!markets["BATSMAN"]) {
      newObj["BATSMAN"] = markets["BATSMAN"];
      delete markets["BATSMAN"];
    }
    if (!!markets["ODD_EVEN"]) {
      newObj["ODD_EVEN"] = markets["ODD_EVEN"];
      delete markets["ODD_EVEN"];
    }
    newObj = { ...newObj, ...markets };
    let fancys = [];
    Object.keys(newObj).forEach((type) => {
      fancys = fancys.concat(newObj[type]);
    });
    return fancys;
  }
  applyFancyFilter(flt) {
    this.setState({ fancyFilter: "" }, () => {
      this.setState({ fancyFilter: flt });
    });
  }
  fancyFilterApply(mktList) {
    let filter = this.state.fancyFilter;
    if (filter !== "all") {
      mktList = mktList.filter((mkt, i) => {
        return mkt.marketType === filter;
      });
    }
    return mktList;
  }
  orderPlaced(ord) {
    let res = [ord];
    if (res[0].marketBettingType === "LINE" && res[0].marketName) {
      res[0].runnerName = res[0].marketName;
    }
    let deactivatMarkets = this.state.deactivatMarkets;
    let data = res.concat(this.state.matched_bet);
    data = data.filter((bet) => {
      return deactivatMarkets.indexOf(bet.marketId) === -1;
    });
    const prfdt = JSON.parse(localStorage.getItem('profData'));
    if(!!prfdt && prfdt.role === 'DemoClient'){
        let demoIdSsData = sessionStorage.getItem('demoIdSsData');
        demoIdSsData = !!demoIdSsData ? JSON.parse(demoIdSsData) : {};
        demoIdSsData[this.props.match.params.event_id] = data
        sessionStorage.setItem('demoIdSsData', JSON.stringify(demoIdSsData));
        setTimeout(()=>{
            document.getElementById('btnHdnRecalculateDemoExpo').click();
        },1000)
    }
    this.setState({ matched_bet: data });
  }
  updateSubscribedMarkets(mkt) {
    let mktList = this.state.subscribedMarkets;
    mktList.push(mkt);
    this.setState({ subscribedMarkets: mktList });
  }
  render() {
    let fancyMarkets = this.arrayGroupBy(this.state.fancyMarkets, "marketType");
    let maketTypeList = Object.keys(fancyMarkets).map((fnc, i) => {
      return (fnc = { mkt: fnc, count: fancyMarkets[fnc].length });
    });
    fancyMarkets = this.orgenizedFancy(fancyMarkets);
    fancyMarkets = this.fancyFilterApply(fancyMarkets);
    let bet_list = this.state.matched_bet;
    const accData = this.getAccountData();
    return (
      <body className="radheexch">
        <Header
          notify={this.props.notify}
          showSweetAlert={(options) => this.props.showSweetAlert(options)}
          MySwal={this.props.MySwal}
          subscribe={(type, id) => {
            this.props.subscribe(type, id);
          }}
          subscriptions={this.props.subscriptions}
          history={this.props.history}
          socket={this.props.socket}
          updateSocket={(skt) => {
            this.updateSocket(skt);
          }}
          orderPlaced={(ord) => {
            this.orderPlaced(ord);
          }}
          resultDeclered={(payload) => {
            this.resultDeclered(payload);
          }}
        />
        <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
          <Menu history={this.props.history} />
          {!!this.state.showToast && (
            <Toast
              notification={this.state.toastMsg}
              type={this.state.toastType}
            />
          )}
          <div className="col-centersdetails markets">
            <div className="">
              <div className=" live-match">
                <div className="sub_path center-box crname">
                  <p>
                    {!!this.state.game &&
                      !!this.state.game.event &&
                      !!this.state.game.competition && (
                        <>
                          {!!this.state.game.catalogues &&
                            this.state.game.catalogues.length > 0 && (
                              <a
                                id="multiMarketPin"
                                title="Remove from Multi Markets"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.toggleMultiMarket(
                                    this.state.game.catalogues[0].marketId
                                  );
                                }}
                                className={
                                  this.state.pinnedEvents.indexOf(
                                    this.state.game.catalogues[0].marketId
                                  ) > -1
                                    ? "multimarket-pin select"
                                    : "multimarket-pin"
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <i
                                  className="fa fa-thumb-tack"
                                  aria-hidden="true"
                                ></i>
                              </a>
                            )}
                          <span style={{ fontSize: 15 }}>
                            {!!this.state.game &&
                              !!this.state.game.event["name"]
                              ? this.state.game.event["name"] + " - Winner"
                              : null}{" "}
                          </span>
                        </>
                      )}
                  </p>
                </div>
                <div className="game-wrap col3">
                  <div className="middle-in-play">
                    <div
                      className={
                        !!this.state.frontData.s &&
                          this.state.frontData.s !== "NA"
                          ? "scorecard m-b-5  scorecard-massage "
                          : "scorecard m-b-5  "
                      }
                    >
                      <div className="row">
                        <div className="col-6 col-md-6">
                          {!!this.state.game && this.state.game.event && (
                            <span
                              className="commentary"
                              style={{ color: "white" }}
                            >
                              <i
                                style={{ color: "white", fontSize: "20" }}
                                className="flaticon-clock"
                                aria-hidden="true"
                              ></i>{" "}
                              {this.formatDate(
                                this.state.game.event["openDate"]
                              )}
                            </span>
                          )}
                        </div>
                        <div className="col-6 col-md-6 ">
                          {!!this.state.game.catalogues &&
                            this.state.game.catalogues.length > 0 && (
                              <span
                                className="commentary"
                                style={{ color: "white", float: "right" }}
                              >
                                {" "}
                                Min:{" "}
                                {this.userPropertyUpdate(
                                  this.state.game.catalogues[0].marketCondition
                                    .minBet
                                )}{" "}
                                | Max:{" "}
                                {this.userPropertyUpdate(
                                  this.state.game.catalogues[0].marketCondition
                                    .maxBet
                                )}{" "}
                              </span>
                            )}
                        </div>
                      </div>
                      {!!this.state.frontData.s &&
                        this.state.frontData.s !== "NA" && (
                          <div className="ballstatuscricket">
                            {this.state.frontData.s === "OVR"
                              ? "Match Over"
                              : this.state.frontData.s === "RAIN"
                                ? "Rain interupted match."
                                : this.state.frontData.s === "TU"
                                  ? "Third Umpire"
                                  : this.state.frontData.s === "NO"
                                    ? "Not Out"
                                    : this.state.frontData.s === "RE"
                                      ? "Review Decision"
                                      : this.state.frontData.s === "DR"
                                        ? "Drinks Break"
                                        : this.state.frontData.s === "LU"
                                          ? "Lunch Break"
                                          : this.state.frontData.s === "TEA"
                                            ? "Tea Break"
                                            : this.state.frontData.s === "IB"
                                              ? "Innings Break"
                                              : this.state.frontData.s === "ST"
                                                ? "Stumps"
                                                : this.state.frontData.s === "DEL"
                                                  ? "Match Delay"
                                                  : this.state.frontData.s === "WOF"
                                                    ? "Wet Out Field"
                                                    : this.state.frontData.s === "OT"
                                                      ? "Out"
                                                      : this.state.frontData.s === "NB"
                                                        ? "No Ball"
                                                        : this.state.frontData.s === "FH"
                                                          ? "Free Hit"
                                                          : this.state.frontData.s === "STO"
                                                            ? "Strategic Time-Out"
                                                            : this.state.frontData.s === "BR"
                                                              ? "Ball Chalu"
                                                              : ""}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                {((!!accData && Object.keys(accData).length > 0) ? socket !== null : true) &&
                  !!this.state.game.catalogues &&
                  this.state.game.catalogues.map((market, i) => {
                    let isMsg = this.state.marketMsg.filter((msg) => {
                      return msg.marketId === market.marketId;
                    });
                    return (
                      <>
                        <WebMarket
                          subscribe={(type, id) => {
                            this.props.subscribe(type, id);
                          }}
                          subscriptions={this.props.subscriptions}
                          subscribedMarkets={this.state.subscribedMarkets}
                          updateSubscribedMarkets={(mkt) => {
                            this.updateSubscribedMarkets(mkt);
                          }}
                          hideMkt={this.state.hideMkt}
                          toggleOpenMkt={(mkt) => {
                            this.toggleOpenMkt(mkt);
                          }}
                          hideHeader={false}
                          feedBooks={this.state.mktFeedBooks}
                          updateBook={(marketId, book) => {
                            this.updateBook(marketId, book);
                          }}
                          loadingBet={this.state.loadingBet}
                          teamSequence={this.state.teamSequence}
                          socket={socket}
                          curBets={this.state.matched_bet}
                          notify={(msg, type) => {
                            this.props.notify(msg, type);
                          }}
                          market={market}
                          addBet={(bet) => {
                            this.addBet(bet);
                          }}
                          selected_market={this.state.selected_market}
                          selcted_bet_option={this.state.selcted_bet_option}
                          msgMarket={isMsg.length > 0 ? isMsg[0].message : ""}
                          betForm={(market, bet, clicked) => {
                            this.betForm(market, bet, clicked);
                          }}
                          toggleMultiMarket={(marketId) => {
                            this.toggleMultiMarket(marketId);
                          }}
                          pinnedEvents={this.state.pinnedEvents}
                          togglebetLoader={()=>this.setState({loadingBet: true})}
                        ></WebMarket>
                      </>
                    );
                  })}
              </div>
              <div className="">
                {this.state.fancyMarkets.length > 0 && (
                  <div className={"live-match"}>
                    <div className="fancybtn-new">
                      <a>
                        <span className="font-weight-bold">Fancy</span>{" "}
                        {this.state.showFancy ? (
                          <i
                            onClick={() => {
                              this.setState({
                                showFancy: !this.state.showFancy,
                              });
                            }}
                            className="fa fa-minus fancyplusminusmob pl-4 "
                            aria-hidden="true"
                          ></i>
                        ) : (
                          <i
                            onClick={() => {
                              this.setState({
                                showFancy: !this.state.showFancy,
                              });
                            }}
                            className="fa fa-plus fancyplusminusmob pl-4"
                            aria-hidden="true"
                          ></i>
                        )}
                      </a>
                    </div>
                    <div className="sub_path center-box fancybg">
                      <ul className="fancy-filter">
                        <li>
                          <a
                            onClick={() => {
                              this.applyFancyFilter("all");
                            }}
                            className={
                              this.state.fancyFilter === "all" ? "active" : null
                            }
                          >
                            All
                          </a>
                        </li>
                        {maketTypeList.map((mktTyp, i) => {
                          return (
                            <li>
                              <a
                                onClick={() => {
                                  this.applyFancyFilter(mktTyp.mkt);
                                }}
                                className={
                                  this.state.fancyFilter === mktTyp.mkt
                                    ? "active"
                                    : null
                                }
                              >
                                <span className="fancynew-budge">
                                  {mktTyp.count}
                                </span>
                                {mktTyp.mkt.replace("_", " ")}
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                      <span
                        className="fancyplus-icon"
                        style={{ color: "white" }}
                      >
                        <a
                          onClick={() => {
                            this.setState({ showFancy: !this.state.showFancy });
                          }}
                        >
                          {this.state.showFancy ? (
                            <i className="fa fa-minus" aria-hidden="true"></i>
                          ) : (
                            <i className="fa fa-plus" aria-hidden="true"></i>
                          )}
                        </a>
                      </span>
                    </div>
                    <div className="fancybgmobile">
                      <div className=" fancyscrollmenu">
                        <a
                          onClick={() => {
                            this.applyFancyFilter("all");
                          }}
                          className={
                            this.state.fancyFilter === "all" ? "active" : null
                          }
                        >
                          All
                        </a>
                        {maketTypeList.map((mktTyp, i) => {
                          return (
                            <a
                              onClick={() => {
                                this.applyFancyFilter(mktTyp.mkt);
                              }}
                              className={
                                this.state.fancyFilter === mktTyp.mkt
                                  ? "active"
                                  : null
                              }
                            >
                              {mktTyp.mkt.replace("_", " ")}
                              <span className="fancynew-budge">
                                {mktTyp.count}
                              </span>
                            </a>
                          );
                        })}
                      </div>
                    </div>
                    <div
                      style={{
                        display: this.state.showFancy ? "block" : "none",
                      }}
                      className="game-wrap col3"
                    >
                      <table className="table w-100 game-list-col fancytable mb-0">
                        <tbody>
                          <tr className="bet-all-new">
                            <td className="pb-0">&nbsp;</td>
                            <td className="w-16 pb-0">
                              <div>
                                <div className="">
                                  <a
                                    id="btnBack"
                                    className="btn-back bg-trans"
                                    side="Back"
                                  >
                                    <span>No</span>
                                  </a>
                                </div>
                                <div>
                                  <a
                                    id="btnLay"
                                    className="btn-lay bg-trans"
                                    side="Lay"
                                  >
                                    <span>Yes</span>
                                  </a>
                                </div>
                              </div>
                            </td>
                            <td className="w-16 mobile-hide pb-0"> &nbsp; </td>
                          </tr>
                          {((!!accData && Object.keys(accData).length > 0) ? socket !== null : true) &&
                            fancyMarkets.map((mkt, i) => {
                              let isMsg = this.state.marketMsg.filter((msg) => {
                                return msg.marketId === mkt.marketId;
                              });
                              return (
                                <>
                                  <Fancybook
                                    subscribe={(type, id) => {
                                      this.props.subscribe(type, id);
                                    }}
                                    subscriptions={this.props.subscriptions}
                                    subscribedMarkets={
                                      this.state.subscribedMarkets
                                    }
                                    updateSubscribedMarkets={(mkt) => {
                                      this.updateSubscribedMarkets(mkt);
                                    }}
                                    feedBooks={this.state.mktFeedBooks}
                                    updateBook={(marketId, book) => {
                                      this.updateBook(marketId, book);
                                    }}
                                    loadingBet={this.state.loadingBet}
                                    key={"fancy_" + i}
                                    socket={socket}
                                    showExpo={(data) => {
                                      this.showExpo(data);
                                    }}
                                    curBets={bet_list}
                                    index={i}
                                    type={"ses"}
                                    notify={(msg, type) => {
                                      this.props.notify(msg, type);
                                    }}
                                    addBet={(bet) => {
                                      this.addBet(bet);
                                    }}
                                    selected_market={this.state.selected_market}
                                    selcted_bet_option={
                                      this.state.selcted_bet_option
                                    }
                                    msgMarket={
                                      isMsg.length > 0 ? isMsg[0].message : ""
                                    }
                                    betForm={(market, bet, clicked) => {
                                      this.betForm(market, bet, clicked);
                                    }}
                                    market={mkt}
                                    toggleMultiMarket={(marketId) => {
                                      this.toggleMultiMarket(marketId);
                                    }}
                                    pinnedEvents={this.state.pinnedEvents}
                                    togglebetLoader={()=>this.setState({loadingBet: true})}
                                  ></Fancybook>
                                </>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
              <div className="live-match livetv">
                {!!this.state.tvUrl && this.state.tvUrl !== "" && (
                  <>
                    <div className="sub_path center-box crname">
                      <p>
                        <span>Live TV</span>
                        <div
                          className="custom-control custom-switch float-right"
                          style={{ display: "inline" }}
                        >
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            checked={this.state.tvShow}
                            onClick={() => {
                              this.setState({ tvShow: !this.state.tvShow });
                            }}
                            id="customSwitches"
                          />
                          <label
                            className="custom-control-label"
                            for="customSwitches"
                          ></label>
                        </div>
                      </p>
                    </div>
                    <div className="game-wrap col3 mb-0">
                      {!!this.state.tvShow && (
                        <div>
                          {" "}
                          <iframe
                            title={"iframe"}
                            key={"iframe"}
                            id="fp_embed_player"
                            src={this.state.tvUrl}
                            marginWidth="0"
                            marginHeight="0"
                            frameBorder="0"
                            width="100%"
                            height="100%"
                            scrolling="no"
                            allowFullScreen="allowfullscreen"
                          ></iframe>
                        </div>
                      )}
                    </div>
                  </>
                )}

                <div className="center-box mt-1">
                  <div className="container-fluid titbg">
                    <div className="w-100 float-left">
                      <span
                        onClick={() => {
                          this.setState({ selected_list: "matched" });
                        }}
                        className={
                          this.state.selected_list === "matched"
                            ? "betslip-btn active"
                            : "betslip-btn"
                        }
                      >
                        Matched Bet
                      </span>
                      {this.state.matched_bet.length > this.state.betLimit && (
                        <a
                          className="view-more-btn"
                          onClick={() => {
                            this.setState({ betSlipOpen: true });
                          }}
                          data-toggle="modal"
                          data-target="#mystatement"
                        >
                          View More
                        </a>
                      )}
                    </div>
                  </div>
                  {this.state.selected_list === "matched" && (
                    <div className="mybet-alldata bg-white table-responsive">
                      <table className="table table-bordered nowrap table-sm font-12 mb-4">
                        <thead>
                          <tr className="bg-dark text-white">
                            <th>Matched Bet</th>
                            <th>Odds</th>
                            <th>Stake</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.matched_bet.map((bet, i) => {
                            return (
                              <>
                                {i < this.state.betLimit && (
                                  <tr
                                    className={
                                      bet.side === "LAY" ? "lay-bg" : "back-bg"
                                    }
                                  >
                                    <td>
                                      {bet.marketBettingType === "LINE"
                                        ? bet.runnerName +
                                        " (" +
                                        bet.price +
                                        ")"
                                        : bet.runnerName +
                                        " - " +
                                        bet.marketName}
                                    </td>
                                    <td>
                                      {bet.marketBettingType === "LINE"
                                        ? bet.runnerId
                                        : bet.price}
                                    </td>
                                    <td>
                                      {bet.amount
                                        ? bet.amount.toFixed(2)
                                        : "0.00"}
                                    </td>
                                  </tr>
                                )}
                              </>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {this.state.selected_list === "unmatched" && (
                    <div className="mybet-alldata bg-white table-responsive">
                      <table className="table table-bordered nowrap table-sm font-12 mb-4">
                        <thead>
                          <tr className="bg-dark text-white">
                            <th>Matched Bet</th>
                            <th>Odds</th>
                            <th>Stake</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.unmatched_bet.map((bet) => {
                            return (
                              <tr
                                className={
                                  bet.side === "LAY" ? "lay-bg" : "back-bg"
                                }
                              >
                                <td>
                                  {bet.marketBettingType === "LINE"
                                    ? bet.runnerName + " (" + bet.price + ")"
                                    : bet.runnerName + " - " + bet.marketName}
                                </td>
                                <td>
                                  {bet.marketBettingType === "LINE"
                                    ? bet.runnerId
                                    : bet.price}
                                </td>
                                <td>
                                  {bet.amount ? bet.amount.toFixed(2) : "0.00"}
                                </td>
                                {/* <td><img alt="" style={{ marginLeft: "38%" }} src={require('../images/close.png')} /></td> */}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={`col-right ${(!!accData && Object.keys(accData).length > 0) ? '' : 'col-right-login'}`}>
            <div className="sub_path over-wrap">
              {!!this.state.tvUrl && this.state.tvUrl !== "" && (
                <>
                  <div className="center-box mb-1 inline">
                    <p>
                      Live TV
                      <div
                        className="custom-control custom-switch float-right"
                        style={{ display: "inline" }}
                      >
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          checked={this.state.tvShow}
                          onClick={() => {
                            this.setState({ tvShow: !this.state.tvShow });
                          }}
                          id="customSwitches"
                        />
                        <label
                          className="custom-control-label"
                          for="customSwitches"
                        ></label>
                      </div>
                    </p>
                  </div>
                  {!!this.state.tvShow && (
                    <div className="mb-2">
                      {" "}
                      <iframe
                        title={"iframe mobile"}
                        key={"iframe_mob"}
                        id="fp_embed_player"
                        src={this.state.tvUrl}
                        marginWidth="0"
                        marginHeight="0"
                        frameBorder="0"
                        width="100%"
                        height="100%"
                        scrolling="no"
                        allowFullScreen="allowfullscreen"
                      ></iframe>
                    </div>
                  )}
                </>
              )}
              <div className="center-box">
                <div className="container-fluid titbg">
                  <div className="w-100 float-left">
                    <span
                      onClick={() => {
                        this.setState({ selected_list: "matched" });
                      }}
                      className={
                        this.state.selected_list === "matched"
                          ? "betslip-btn active"
                          : "betslip-btn"
                      }
                    >
                      Matched Bet
                    </span>
                    {this.state.matched_bet.length > this.state.betLimit && (
                      <a
                        className="view-more-btn"
                        onClick={() => {
                          this.setState({ betSlipOpen: true });
                        }}
                        data-toggle="modal"
                        data-target="#mystatement"
                      >
                        View More
                      </a>
                    )}
                  </div>
                </div>
                {this.state.selected_list === "matched" && (
                  <div className="mybet-alldata bg-white table-responsive">
                    <table className="table table-bordered nowrap table-sm font-12 mb-4">
                      <thead>
                        <tr className="bg-dark text-white">
                          <th>Matched Bet</th>
                          <th>Odds</th>
                          <th>Stake</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.matched_bet.map((bet, i) => {
                          return (
                            <>
                              {i < this.state.betLimit && (
                                <tr
                                  className={
                                    bet.side === "LAY" ? "lay-bg" : "back-bg"
                                  }
                                >
                                  <td>
                                    {bet.marketBettingType === "LINE"
                                      ? bet.runnerName + " (" + bet.price + ")"
                                      : bet.runnerName + " - " + bet.marketName}
                                  </td>
                                  <td>
                                    {bet.marketBettingType === "LINE"
                                      ? bet.runnerId
                                      : bet.price}
                                  </td>
                                  <td>
                                    {bet.amount
                                      ? bet.amount.toFixed(2)
                                      : "0.00"}
                                  </td>
                                </tr>
                              )}
                            </>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
                {this.state.selected_list === "unmatched" && (
                  <div className="mybet-alldata bg-white table-responsive">
                    <table className="table table-bordered nowrap table-sm font-12 mb-4">
                      <thead>
                        <tr className="bg-dark text-white">
                          <th>Matched Bet</th>
                          <th>Odds</th>
                          <th>Stake</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.unmatched_bet.map((bet) => {
                          return (
                            <tr
                              className={
                                bet.side === "LAY" ? "lay-bg" : "back-bg"
                              }
                            >
                              <td>
                                {bet.marketBettingType === "LINE"
                                  ? bet.runnerName + " (" + bet.price + ")"
                                  : bet.runnerName + " - " + bet.marketName}
                              </td>
                              <td>
                                {bet.marketBettingType === "LINE"
                                  ? bet.runnerId
                                  : bet.price}
                              </td>
                              <td>
                                {bet.amount ? bet.amount.toFixed(2) : "0.00"}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
          {this.state.showExpo && (
            <ExpoPopup
              lineExpo={this.state.lineExpo}
              hidePopup={() => {
                this.hidePopup();
              }}
            />
          )}
          {this.state.betSlipOpen && (
            <BetSlipPopup
              bets={this.state.matched_bet}
              hidePopup={() => {
                this.hidePopup();
              }}
            />
          )}
        </div>
      </body>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(Event);
